import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { LogIn, ShieldCheck } from "lucide-react";
import { useAuth } from "../lib/AuthContext";
import { useI18n } from "../lib/i18n";

export default function LoginPage() {
  const { user, loading, login } = useAuth();
  const navigate = useNavigate();
  const { locale } = useI18n();
  const isDE = locale === "de";

  useEffect(() => {
    if (!loading && user) navigate(user.role === "admin" ? "/admin" : "/account", { replace: true });
  }, [user, loading, navigate]);

  return (
    <main className="min-h-[80vh] bg-brand-ink flex items-center justify-center px-6 pt-28 pb-16" data-testid="login-page">
      <div className="glass-strong rounded-3xl p-8 md:p-12 max-w-md w-full text-center relative overflow-hidden">
        <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-brand-orange/15 blur-3xl pointer-events-none" />
        <div className="relative">
          <div className="w-14 h-14 mx-auto rounded-2xl bg-brand-orange/12 border border-brand-orange/40 flex items-center justify-center mb-6">
            <ShieldCheck className="w-6 h-6 text-brand-orange" />
          </div>
          <h1 className="font-display font-bold text-2xl md:text-3xl text-white tracking-tight">
            {isDE ? "Kundenbereich" : "Client Area"}
          </h1>
          <p className="mt-3 text-sm text-white/60 leading-relaxed">
            {isDE
              ? "Melde dich mit Google an, um deine Anfragen einzusehen. Agentur-Admins gelangen zum Dashboard."
              : "Sign in with Google to view your inquiries. Agency admins are taken to the dashboard."}
          </p>
          <button
            onClick={login}
            data-testid="google-login-btn"
            className="mt-8 w-full inline-flex items-center justify-center gap-2.5 px-6 py-3.5 rounded-full bg-white text-[#0D1B2A] font-semibold text-sm hover:bg-white/90 transition-all hover:-translate-y-0.5"
          >
            <svg className="w-4 h-4" viewBox="0 0 24 24" aria-hidden>
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.27-4.74 3.27-8.1z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.1c-.22-.66-.35-1.36-.35-2.1s.13-1.44.35-2.1V7.06H2.18A10.97 10.97 0 0 0 1 12c0 1.77.42 3.45 1.18 4.94l3.66-2.84z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84c.87-2.6 3.3-4.52 6.16-4.52z"/>
            </svg>
            <LogIn className="w-4 h-4" />
            {isDE ? "Mit Google anmelden" : "Sign in with Google"}
          </button>
          <p className="mt-6 text-[11px] font-mono text-white/35">
            {isDE ? "Sicher via Google OAuth · Keine Passwörter" : "Secured via Google OAuth · No passwords"}
          </p>
        </div>
      </div>
    </main>
  );
}
